import type {
  Company,
  CompanyListParams,
  CompanyPagedList,
  CompanyPagedListResponse,
  CompanyResponse,
  CreateCompanyRequest,
  UpdateCompanyBrandingRequest,
  UpdateCompanyRequest,
} from '@apiContract';

import { receivedDigitalApi } from './index';

const companyApi = receivedDigitalApi.injectEndpoints({
  endpoints: (builder) => ({
    getCompany: builder.query<Company, number>({
      query: (id) => `Company/${id}`,
      providesTags: ['Company'],
      transformResponse: (response: CompanyResponse) => response.objectData,
    }),

    createCompany: builder.mutation<Company, CreateCompanyRequest>({
      query: (requestData) => ({
        url: 'Company',
        method: 'POST',
        body: requestData,
      }),
      transformResponse: (response: CompanyResponse) => response.objectData,
    }),

    updateCompany: builder.mutation<Company, UpdateCompanyRequest>({
      query: (requestData) => ({
        url: 'Company',
        method: 'PUT',
        body: requestData,
      }),
      invalidatesTags: ['Company'],
      transformResponse: (response: CompanyResponse) => response.objectData,
    }),

    createUserCompany: builder.mutation<Company, CreateCompanyRequest>({
      query: (requestData) => ({
        url: 'Company/CreateUserCompany',
        method: 'POST',
        body: requestData,
      }),
      invalidatesTags: ['Company', 'User'],
      transformResponse: (response: CompanyResponse) => response.objectData,
    }),
    getCompaniesFiltered: builder.query<CompanyPagedList, CompanyListParams>({
      query: (requestParams) => ({ url: 'Company', params: requestParams }),
      transformResponse: (response: CompanyPagedListResponse) => response.objectData,
    }),
    uploadLogo: builder.mutation<Company, UpdateCompanyBrandingRequest>({
      query: (requestData) => ({
        url: 'Company/branding',
        method: 'PUT',
        body: requestData,
      }),
      invalidatesTags: ['Company', 'User'],
      transformResponse: (response: CompanyResponse) => response.objectData,
    }),
  }),
});

export const {
  useLazyGetCompanyQuery,
  useCreateCompanyMutation,
  useUpdateCompanyMutation,
  useCreateUserCompanyMutation,
  useGetCompaniesFilteredQuery,
  useUploadLogoMutation,
} = companyApi;
